<script setup>
import {ref, onBeforeMount} from "vue"
import {getRoute} from "@/hooks/getRoute.js";
const {route} = getRoute();
import router from "@/router/index.js";
import {userLoginHooks, userLogoutHooks} from "@/hooks/user.js";
import {userInfoStore} from "@/store/store.js";
import {createClubQrCode} from "@/api/club/club.js";
import { CaretBottom, Select, CaretTop } from "@element-plus/icons-vue";
import { ClickOutside as vClickOutside } from 'element-plus'
import {listStoreByTenantId, merchantChangeStore} from "@/api/login/login.js";
import {menuListHooks} from "@/hooks/menu.js";
import {menuStore} from "@/store/store.js";

const userInfo = ref(userInfoStore().info);

onBeforeMount(async() => {
  loading.value = true
  await handleGetStoreList()
  await menuListHooks()
  // 获取菜单信息
  await getMenu()
  loading.value = false
})

// 获取当前用户菜单列表
async function getMenu() {
  list.value = menuStore().menu.menuList
}

/*logo相关*/
// logo跳转链接
const logoLink = ref("/listMember")
// 菜单列表
const list = ref([
  // {
  //   menuName: "会员管理",
  //   menuCode: "#1",
  //   icon: "https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/menu/menu/menu_manage_user.svg",
  //   iconActive: "https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/menu/menu/menu_manage_user_active.svg",
  //   iconActiveHover: "https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/menu/menu/menu_manage_user_active_hover.svg",
  //   link: "/store/listUser",
  //   isHover: false
  // },
  // {
  //   menuName: "活动管理",
  //   menuCode: "#2",
  //   icon: "https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/menu/menu/menu_manage_activity.svg",
  //   iconActive: "https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/menu/menu/menu_manage_activity_active.svg",
  //   iconActiveHover: "https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/menu/menu/menu_manage_activity_active_hover.svg",
  //   link: "/store/listActivity",
  //   isHover: false
  // },
  // {
  //   menuName: "管理俱乐部",
  //   menuCode: "#3",
  //   icon: "https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/menu/menu/menu_manage_club.svg",
  //   iconActive: "https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/menu/menu/menu_manage_club_active.svg",
  //   iconActiveHover: "https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/menu/menu/menu_manage_club_active_hover.svg",
  //   link: "/store/manageClub",
  //   isHover: false
  // },
  // {
  //   menuName: "设置",
  //   menuCode: "#4",
  //   icon: "https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/menu/menu/menu_setting.svg",
  //   iconActive: "https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/menu/menu/menu_setting_active.svg",
  //   iconActiveHover: "https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/menu/menu/menu_setting_active_hover.svg",
  //   link: "/store/settings",
  //   isHover: false
  // }
])
// 链接跳转
function jumpTo(items) {
  console.log("items", items)
  if (items.link === route.path) {
    console.log("跳转至当前页面，return")
    return
  }
  if (items.link) router.push(items.link)
}
// 是否展示其余门店弹窗
const isShowOtherStore = ref(false)
// 鼠标点击外部关闭下拉面板
const handleClickOutside = () => {
  isShowOtherStore.value = false
}

const showLogout = () => {
  logout_show.value = true
}
// 登出
const handleLogout = () => {
  userLogoutHooks()
}
// 俱乐部加入码弹窗打开状态
const open = ref(false)
// 处理俱乐部邀请码下载
const handleDownloadQR = () => {
  ElMessage.warning("下载中...")
  window.location.href = showQrCodeUrl.value
}
/*店铺身份切换相关*/
// 菜单全局loading
const loading = ref(false)
// 店铺列表
const storeList = ref([])
// 处理获取店铺列表
const handleGetStoreList = async () => {
  try {
    let page = {
      page: 1,
      pageSize: 100,
    }
    console.log("userInfo", userInfo.value)
    let param = {
      tenantId: userInfo.value.tenantId,
      adminId: userInfo.value.adminId
    }
    const res = await listStoreByTenantId(page, param)
    storeList.value = res.list
  } catch (e) {
    console.log(e)
  }
}
// 处理切换店铺
const handleSelectStore = async (storeInfo) => {
  console.log("storeInfo", storeInfo)
  console.log("userInfo.storeId", userInfo.value.storeId)
  if (storeInfo.storeId === userInfo.value.storeId) {
    console.log("相同storeId，不进行切换")
    return
  }
  try {
    loading.value = true
    const res = await merchantChangeStore(storeInfo.storeId)
    await userLoginHooks(res, false);
    router.go();
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

// 退出登录弹窗相关
const logout_show = ref(false)

// 缓存查看的二维码地址
const showQrCodeUrl = ref(null)
// 二维码弹窗加载状态
const dialogLoading = ref(false)

// 处理打开俱乐部邀请二维码
const handleOpenClubQR = async () => {
  open.value = true
  const clubQR = userInfo.value.storeQrCode
  if (clubQR && clubQR !== "") {
    showQrCodeUrl.value = clubQR
  } else {
    try {
      dialogLoading.value = true
      const res = await createClubQrCode()
      console.log("==handleOpenClubQR res", res)
      showQrCodeUrl.value = res
      dialogLoading.value = false
    } catch (e) {
      console.log(e)
      dialogLoading.value = false
    }
  }
}
// 处理菜单栏鼠标移入事件
const handleMenuMouseEnter = (item) => {
  item.isHover = true
}
// 处理菜单栏鼠标移出事件
const handleMenuMouseLeave = (item) => {
  item.isHover = false
}


</script>

<template>
  <div class="new_menu_box mg_r_1" v-loading="loading">
    <div style="margin-bottom: 22px;position: relative" @click.stop="isShowOtherStore = !isShowOtherStore" v-click-outside="handleClickOutside">
      <el-tooltip
          class="box-item"
          effect="dark"
          content="切换账户管理身份"
          placement="right"
          offset="29"
          :show-arrow="false"
      >
        <div class="flex_bt logo_box">
          <div class="flex_center">
            <img class="logo" v-if="userInfo.storeLogo !== '' && userInfo.storeLogo !== null" style="margin: 0 14px 0 16px;" :src="userInfo.avatar" alt="">
            <div class="logo noLogo" v-else style="margin: 0 14px 0 16px;">LOGO</div>
            <div class="logo_txt txt_nowrap txt_overflow">{{userInfo.storeName}}</div>
          </div>
          <div>
            <el-icon :size="17">
              <CaretBottom :style="`transition: .3s;transform: rotate(${isShowOtherStore ? '180' : '0'}deg)`"/>
            </el-icon>
          </div>
        </div>
      </el-tooltip>
      <transition name="el-zoom-in-top">
        <div class="logo_select_box" v-show="isShowOtherStore" @click.stop>
          <div class="logo_select_item" v-for="(item, index) in storeList" :key="`logo_select_item${index}`" @click="handleSelectStore(item)">
            <el-tooltip
                class="box-item"
                effect="dark"
                :content="item.name"
                placement="right"
            >
              <div class="flex_left">
                <div class="active" v-show="item.storeId === userInfo.storeId">
                  <el-icon :size="14"><Select /></el-icon>
                </div>
                <div class="txt_overflow">
                  {{item.name}}
                </div>
              </div>
            </el-tooltip>
          </div>
        </div>
      </transition>
    </div>
    <!--  TODO 当前菜单栏菜单不多，暂不考虑滚动条样式  -->
    <div class="new_menu_item_box">
      <div @mouseenter="handleMenuMouseEnter(item)" @mouseleave="handleMenuMouseLeave(item)" @click="jumpTo(item)" style="margin-bottom: 5px;" :class="item.menuCode === route.meta.open[0] ? 'flex_center flex_left new_menu_item_active' : 'flex_center flex_left new_menu_item'" v-for="(item, index) in list" :key="`menu${index}`">
        <img v-if="item.menuCode === route.meta.open[0] && !item.isHover" :src="item.iconActive" class="new_menu_item_icon"/>
        <img v-else-if="item.menuCode === route.meta.open[0] && item.isHover" :src="item.iconActiveHover" class="new_menu_item_icon"/>
        <img v-else :src="item.icon" class="new_menu_item_icon" />
        <div class="new_menu_item_txt">{{item.menuName}}</div>
      </div>
      <div @click="showLogout()" class="flex_center flex_left new_menu_item">
        <img src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/menu/menu/menu_logout.svg" class="new_menu_item_icon" />
        <div class="new_menu_item_txt">登出</div>
      </div>
    </div>
    <div class="new_menu_bottom_box" style="">
      <div class="new_menu_bottom_qr_box flex_left mg_b_2"
           @click="handleOpenClubQR"
           v-if="userInfo.storeType === 'CLUB' ||
           userInfo.storeType === 'BIKE_STORE' ||
           userInfo.storeType === 'STATION' ||
           userInfo.storeType === 'BMX_VENUE' ||
           userInfo.storeType === 'MOUNTAIN_BIKE_VENUE' ||
           userInfo.storeType === 'PUMP_TRACK_VENUE' ||
           userInfo.storeType === 'TENNIS_VENUE'">
        <div class="new_menu_bottom_qr_icon_bg flex_center mg_l_1" style="margin-right: 6px;">
          <img class="new_menu_bottom_qr_icon" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/menu/menu/menu_bottom_qr.svg">
        </div>
        <div style="margin-right: 8px">专属二维码</div>
        <img src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/menu/menu/menu_bottom_arrow_right.svg">
      </div>
      <div class="flex_left" style="margin-bottom: 17px">
        <img class="new_menu_bottom_logo_box" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/menu/menu/menu_bikingup_logo.png">
      </div>
      <div class="flex_left flex-wrap" style="margin-left: 10px">
        <div class="new_menu_bottom_info">全国客服热线：400-8032-881</div>
        <div class="new_menu_bottom_info">客服邮箱：enquiry@bikingup.cc</div>
        <div class="new_menu_bottom_info">服务时间：周一至周五10:00-17:00</div>
      </div>
    </div>
  </div>
  <!-- 俱乐部二维码弹窗 -->
  <el-dialog
      id="dialog"
      v-model="open"
      width="400"
      style="padding: 20px"
      :close-on-press-escape="false"
      :show-close="false">
    <template #header>
      <div class="yt_dialog_title" style="text-align: center;padding-left: 0;">会员扫码&emsp;加入俱乐部</div>
    </template>
    <div class="yt_dialog_container flex_center" style="padding-left: 0">
      <el-image style="width: 216px; height: 216px" :src="showQrCodeUrl" fit="contain" v-loading="dialogLoading"/>
    </div>
    <template #footer>
      <div class="flex_center" style="padding-top: 11px;padding-bottom: 31px;">
        <div class="qr_download_btn flex_center" @click="handleDownloadQR">
          <div>下载保存</div>
        </div>
      </div>
    </template>
  </el-dialog>

  <!-- 登出弹窗 -->
  <el-dialog
    v-model="logout_show"
    align-center
    :show-close="false"
    width="540px"
  >
  <template #header>
    <div class="logout_header fwb txt_left">是否退出登录？</div>
  </template>
  <span>退出登录当前账号不会丢失任何数据，你仍可以重新登录此账号</span>
  <template #footer>
      <div class="dialog-footer mt60">
        <button class="logout_cancel br10" @click="logout_show = false">取消</button>
        <button class="logout_confirm br10 ml20" @click="handleLogout">
          确定登出
        </button>
      </div>
    </template>
  </el-dialog>
</template>

<style lang="scss" scoped>
.logo_box {
  cursor: pointer;
  position: relative;

}
.logo_select_box {
  position: absolute;
  bottom: -9px;
  right: 3px;
  background-color: #fff;
  width: 200px;
  height: 170px;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 7px 11px;
  transform: translateY(100%);
  box-shadow: 0 1px 6px 0 rgba(25,24,27,0.1);
  border: 1px solid #EDEFF4;
  overflow: auto;
  .logo_select_item {
    position: relative;
    width: 100%;
    height: 37px;
    background: #fff;
    font-family: OPPOSans;
    font-weight: 500;
    font-size: 14px;
    color: #272539;
    line-height: 37px;
    transition: .2s;
    box-sizing: border-box;
    padding-left: 51px;
    text-align: left;
    user-select: none;
    .active {
      position: absolute;
      top: 50%;
      left: 21px;
      transform: translateY(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .logo_select_item:hover {
    background: #EFF1F7;
    border-radius: 6px;
    border: 1px solid #EDEFF4;
    line-height: 35px;
    transition: .2s;
    cursor: pointer;
  }
}
.logo {
  width: 46px;
  height: 46px;
  border-radius: 46px;
}
.noLogo {
  width: 46px;
  height: 46px;
  border-radius: 46px;
  background-color: #F0F0F0;
  text-align: center;
  color: #414141;
  line-height: 46px;
  font-size: 10px;
}
.logo_txt {
  max-width: 160px;
  font-family: OPPOSans,sans-serif;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 500;
}
.logo_box:hover .logo_txt{
  text-decoration: underline;
}
.qr_download_btn {
  height: 32px;
  background: #ECECF4;
  border-radius: 6px;
  font-weight: 500;
  font-size: 16px;
  color: #77788E;
  cursor: pointer;
  box-sizing: border-box;
  padding: 0 30px;
}
.logout_cancel{
  background-color: #D7D7DF;
  color: #272539;
}
.logout_confirm{
  background-color: #4CAF50;
  color: #fff;
}
</style>
